import clearForm from "./clearForm";
import notification from "./notification";
// import {NotificationManager} from "react-notifications";

export default function(self, obj, refreshGrid) {
  //arguments
  if (
    self.props.update.messageType === "error" ||
    self.props.update.messageType === "warning" ||
    self.props.update.messageType === "success"
  ) {
    notification(
      self.props.update.messageType,
      self.props.update.messageType,
      self.props.update.message
    );
    self.props.clearUpdate();
  } else {
    if (self.props.update.data && self.props.update.action === "add") {
      if (obj) {
        self.props[obj].push(self.props.update.data);
        self.gridApi.updateRowData({ add: [self.props.update.data] });
      }

      notification(
        "success",
        "Success",
        `${self.props.update.page} saved successfully`
      );

      // NotificationManager.info("Sucess","title");
      self.props.clearUpdate();
      clearForm(self);
      if (refreshGrid) {
        self.componentWillMount();
      }
    } else if (self.props.update.data && self.props.update.action === "edit") {
      self.props[obj][self.props.update.nodeId] = self.props.update.data;
      self.gridApi.setRowData(self.props[obj]);
      self.setState({ Id: 0 });
      notification(
        "success",
        "Success",
        `${self.props.update.page} updated successfully`
      );
      self.props.clearUpdate();
      clearForm(self);
      if (refreshGrid) {
        self.componentWillMount();
      }
    } else if (
      self.props.update.data &&
      self.props.update.action === "delete"
    ) {
      self.props[obj].splice(self.props.update.nodeId, 1);
      self.gridApi.setRowData(self.props[obj]);
      notification("warning", "Deleted", "Item Deleted successfully");
      self.props.clearUpdate();
      if (refreshGrid) {
        self.componentWillMount();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/updateGrid.js